@if (showShell()) {
  <div class="nv-shell" [class.nv-shell--collapsed]="railCollapsed()" [class.nv-shell--footer]="showShiftFooter()">
    @if (tenancy.impersonating()) {
      <div class="nv-shell__impersonation">
        <span>
          Viewing as this venue's owner — impersonated by
          {{ tenancy.impersonatedByEmail() ?? 'Root' }}. This is not your own account.
        </span>
        <button type="button" nvButton="secondary" size="xs" (click)="endImpersonation()">End session</button>
      </div>
    }

    <div class="nv-shell__body">
      @if (isNarrow() && railOpen()) {
        <button type="button" class="nv-shell__scrim" aria-label="Close navigation" (click)="railOpen.set(false)"></button>
      }

      <aside
        class="nv-shell__rail"
        [class.nv-shell__rail--open]="railOpen()"
        [class.nv-shell__rail--overlay]="isNarrow()"
      >
        <nv-rail [collapsed]="railCollapsed() && !isNarrow()" />
      </aside>

      <div class="nv-shell__main">
        <nv-header [pageTitle]="pageTitle()" [pageCrumb]="pageCrumb()" (toggleRail)="toggleRail()" />

        <nv-offline-banner />

        <div class="nv-shell__content nvx-scroll">
          <router-outlet />
        </div>

        <!-- Round 4, §2 — the mock's status bar (mock:1939-1970), a normal
             flex sibling of .nv-shell__content so it sits in the page's own
             flow at the bottom of this column, unlike the dock below it. -->
        <nv-shift-footer />

        <!-- Item 15 — the mock's real floating/draggable/resizable/tabbed
             dock, outside .nv-shell__content deliberately: it's
             position:fixed and must float over whatever page is
             underneath, not scroll with it. -->
        <nv-requests-tasks-dock [showTasksTab]="previewFeatures" />

        <!-- What the chef and waiter screens tell the manager, on every page. -->
        <nv-kitchen-ready-alerts />
      </div>
    </div>
  </div>
} @else {
  <nv-offline-banner />
  <router-outlet />
}
